export var isBrowser = typeof window !== 'undefined';
